<template>
  <div :style="{'min-height': minHeight + 'px'}" class="bigBody" id="index">
    <!--<myhead></myhead>-->
<!--    :style="{'height':minHeight + 'px'}"-->
  <div class="bodytop p_r">
    <img style="margin: 10px" src="../../assets/takitaLogo.png" width="5%">
    <span style="font-family: Gotham-Medium" class="f_w font18 m_l_5">WeChat Enterprise Platform</span>
    <div class="admin" >
  <!--    <i class="icon iconfont iconusers"></i>&nbsp;管理员-->
<!--      <logName class="allLoginNamePlace"></logName>-->
      <div>您好，{{userInfo.displayName || '用户'}} 欢迎登录</div>
    </div>
  </div>
    <div :style="{'min-height': minHeightRight + 'px'}" id="bodyleft" >
      <myleft :minHeight="minHeight"></myleft>
      <!-- <div @click="logout" style="height: 50px;line-height: 50px;width: 100%;text-align: center">
        <span class="loginOut"><i class="icon iconfont icontuichu"></i><abbr style="vertical-align: baseline;" class="m_l_5">退出账号</abbr></span>
      </div> -->
    </div>
    <div :style="{'height': minHeightRight + 'px'}" style="overflow: auto" id="bodyright">
<!--    <myhead></myhead>-->
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
    <!-- <section id="copyRight" style="100%">Classified information:Internal</section> -->
  </div>
</template>

<script>
import left from '../left-menu/menu'
export default {
  name: 'index',
  data () {
    return {
      minHeight: 1080,
      minHeightRight: 1080,
      loginName: '',
      rightBodyHeight: 0,
      userInfo: JSON.parse(window.localStorage.getItem('userInfo') || {})
    }
  },
  created () {
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    console.log()
    this.minHeight = window.innerHeight - 105
    this.minHeightRight = window.innerHeight - 70
    this.rightBodyHeight = document.getElementById('bodyleft').innerHeight
    console.log(this.minHeight)
    console.log(document.getElementById('index').clientWidth)
    // if (document.getElementById('index').clientWidth < 1370) {
    //   this.minHeight = this.minHeight * 1.2
    //   this.minHeightRight = this.minHeightRight * 1.2
    // }
    // let dom = document.querySelector('#bodyright')
    // if (dom !== null) {
    //   dom.onscroll = p => {
    //     console.log(p.target.scrollHeight)
    //   }
    // }
  },
  methods: {
    logout () {
      this.$commonJs.doubleComfirm({
        content: '是否确定退出？',
        successFun: msg => {
          window.sessionStorage.removeItem('userInfo')
          window.sessionStorage.removeItem('AppId')
          window.sessionStorage.removeItem('nowApp')
          window.sessionStorage.removeItem('promissions')
          window.sessionStorage.removeItem('token')
          this.$router.push('/login')
        },
        errorFun: msg => {
        }
      })
    }
  },
  components: {
    'myleft': left
  }
}
</script>

<style scoped>
  #index{
    background: #f1f1f1;
  }
  .bodytop{
    background-color: #fff;
    /*height: 80px;*/
    /*margin: 3px;*/
  }
  .userInfo{
    text-align: center;
    width: 100%;
    margin-top: 5%;
    position: absolute;
    bottom: 5%;
    color: #999;
  }
  .userInfo p i{
    color: #C73343;
  }
  .userInfo p:nth-child(2){
    margin-top: 10px;
    color: #333;
  }
  #copyRight{
    position: absolute;
    bottom: 0px;
    background: #f8f8f8;
    padding: 10px 0;
    left: 200px;
    width: calc(100% - 200px);
    text-align: center;
  }
  .loginOut{
    padding: 8px 30px;
    border-radius: 30px;
    background-color: rgba(0 ,0 ,0 , 0.5);
  }
  .admin{
    position: absolute;
    right: 2%;
    top:0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #737373;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue